import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/home/ubuntu/download/69a6d74e4fab3d0014eb29f1/sebnorge/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/home/ubuntu/download/69a6d74e4fab3d0014eb29f1/sebnorge/src/contexts/LanguageContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/69a6d74e4fab3d0014eb29f1/sebnorge/src/styles/index.css");
